import useAuth from '@app/auth/use-auth';
import { IngredientModelledAsEnum } from '@shared/api/types';
import { Icons } from '@shared/components/content/icons';

export const useIngredientModellingOptions = () => {
  const { user } = useAuth();
  const { features } = user || {};
  const hasAccessToPg = !!(features?.ccf || features?.scope3);
  return [
    {
      label: 'Basic food',
      value: IngredientModelledAsEnum.basic_food,
      icon: <Icons.carrot className="size-4" />,
      description: 'Match to a single item in our database',
    },
    {
      label: 'Recipe',
      value: IngredientModelledAsEnum.modelled_food,
      icon: <Icons.chefHat className="size-4" />,
      description: 'Input or generate a recipe',
    },
    {
      label: 'External product assessment',
      value: IngredientModelledAsEnum.external_emission_factor,
      icon: <Icons.arrowUpCircle className="size-4" />,
      description: 'Enter an emission factor from elsewhere',
    },
    ...(hasAccessToPg
      ? [
          {
            label: 'Another item in my account',
            value: IngredientModelledAsEnum.purchased_good,
            icon: <Icons.salad className="size-4" />,
            description: 'Link to a purchased good in your account',
          },
        ]
      : []),
  ];
};
